import React, { useRef } from "react";

import { useLocation, useNavigate } from "react-router";

import { PageHeader } from "components/PageHeader";

import { IFullView } from "./interface";
import { Container, ContainerVideo } from "./styles";
import { VideoPlayer } from "../../Video";
import RightTemplate from "../RightTemplate";

export const FullView: React.FC<IFullView> = ({
  title,
  transcription,
  summary,
  mark,
  ata,
  videoComponente,
  setPage,
  loadingAba,
  hearing,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dataLocation = location.state?.audience || hearing;
  const defaultPage = location.state?.page;
  const videoRef = useRef<HTMLVideoElement>(null);

  return (
    <Container>
      <PageHeader
        label={title}
        background="primary"
        backClick={() => navigate(`/audiences`, { state: dataLocation })}
      />
      <ContainerVideo>
        <VideoPlayer {...videoComponente} videoRef={videoRef} />
        <RightTemplate
          transcription={transcription}
          summary={summary}
          mark={mark}
          ata={ata}
          defaultPage={defaultPage}
          setPage={setPage}
          loadingAba={loadingAba}
          videoRef={videoRef}
          hearing={dataLocation}
        />
      </ContainerVideo>
    </Container>
  );
};
